import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as uiModalActionRendering from './ui-modal-action-rendering'
import * as uiNavigateActionRendering from './ui-navigate-action-rendering'
import * as uiOpenAssistantActionRendering from './ui-open-assistant-action-rendering'
import * as uiSetVariablesActionRendering from './ui-set-variables-action-rendering'
import * as uiSlideoutActionRendering from './ui-slideout-action-rendering'

export const DOC = gql`
  ${uiNavigateActionRendering.DOC}
  ${uiModalActionRendering.DOC}
  ${uiSlideoutActionRendering.DOC}
  ${uiSetVariablesActionRendering.DOC}
  ${uiOpenAssistantActionRendering.DOC}
  fragment FragmentMosaicUiActionRendering on MosaicUiActionRendering {
    __typename
    ...FragmentMosaicUiNavigateActionRendering
    ...FragmentMosaicUiModalActionRendering
    ...FragmentMosaicUiSlideoutActionRendering
    ...FragmentMosaicUiSetVariablesActionRendering
    ...FragmentMosaicUiOpenAssistantActionRendering
  }
`
export const TRANSFORMER = graphql.transformers.OUT.discriminateOn<
  graphql.schema.FragmentMosaicUiActionRenderingFragment,
  ents.core.mosaic.Action.Rendering.OfUiOperationsOnly,
  '__typename'
>('__typename', {
  MosaicUiModalActionRendering: uiModalActionRendering.TRANSFORMER,
  MosaicUiNavigateActionRendering: uiNavigateActionRendering.TRANSFORMER,
  MosaicUiOpenAssistantActionRendering:
    uiOpenAssistantActionRendering.TRANSFORMER,
  MosaicUiSetVariablesActionRendering:
    uiSetVariablesActionRendering.TRANSFORMER,
  MosaicUiSlideoutActionRendering: uiSlideoutActionRendering.TRANSFORMER,
})
